
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import Colors from '../../components/theme-colors'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "design-tokens"
    }}>{`Design Tokens`}</h1>
    <p>{`All components in VCC UI are derived from a set of design tokens. These are basically properties describing each design attribute of a given component.`}</p>
    <p>{`Theoretically these could be used to build components in another framework and make sure they still align to the overall web design system.`}</p>
    <p>{`There are also low level design tokens like colors, spacing, typography and grid, which would allow you to build your own custom component from scratch.`}</p>
    <h2 {...{
      "id": "colors"
    }}>{`Colors`}</h2>

    <p>{`This is a design token reference of all colors being used in VCC UI. Learn `}<a parentName="p" {...{
        "href": "/docs/theming#accessing-theme-props"
      }}>{`how to use theme colors`}</a>{` in the theming documentation. You can toggle the theme on this page to see how the colors will change.`}</p>
    <Colors mdxType="Colors" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;